import { render, staticRenderFns } from "./CadCancelarProcessoAtaDirex.vue?vue&type=template&id=579a4efa"
import script from "./CadCancelarProcessoAtaDirex.vue?vue&type=script&lang=js"
export * from "./CadCancelarProcessoAtaDirex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports